// extracted by mini-css-extract-plugin
export default {"main-title":"s_main-title__7gaQ6","graduates-wrapper":"s_graduates-wrapper__3VZDk","item":"s_item__tMzST"};